import { render } from "./LeadgenFormLeadsHeader.vue?vue&type=template&id=7885ac63"
import script from "./LeadgenFormLeadsHeader.vue?vue&type=script&lang=js"
export * from "./LeadgenFormLeadsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/LeadgenFormLeadsHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7885ac63"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7885ac63', __exports__)) {
    api.reload('7885ac63', __exports__)
  }
  
  module.hot.accept("./LeadgenFormLeadsHeader.vue?vue&type=template&id=7885ac63", () => {
    api.rerender('7885ac63', render)
  })

}


export default __exports__